import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {selectDealInvites} from 'api/deals';
import {selectUserLoaded} from 'flows/session/selectors';
import {sendInvite as invite} from 'flows/deal/invite/index';

import Spinner from 'components/Spinner';
import Button from 'components/Button';
import InvestorInviteContainer from './components/InvestorInvite';

import './style.css';

export class InvitedInvestors extends React.Component {
  render() {
    const {userLoaded} = this.props;
    const {loaded, data: invites} = this.props.invites || {};
    if (loaded && userLoaded) {
      return (
        <div>
          <header styleName="header">
            <h2 styleName="h2">Investors</h2>
            <Button
              onClick={() => {
                this.props.invite({
                  deal: this.props.deal,
                });
              }}
              style={{margin: '-1em 0px 1em'}}
              data-test="invite"
            >Invite Investors
            </Button>
          </header>
          <section styleName="table">
            {invites.map(invite => <InvestorInviteContainer invite={invite} deal={this.props.deal} key={invite.id} />)}
          </section>
        </div>
      );
    } else {
      return (
        <div style={{textAlign: 'center'}}>
          <Spinner />
        </div>
      )
    }
  }
}

InvitedInvestors.propTypes = {
  invite: PropTypes.func.isRequired,
  invites: PropTypes.object,
  deal: PropTypes.object.isRequired,
  userLoaded: PropTypes.bool.isRequired
};

export const mapStore = (store, props) => ({
  invites: selectDealInvites(store, props.deal.id),
  userLoaded: selectUserLoaded(store),
});

export default connect(mapStore, {invite})(InvitedInvestors);



// WEBPACK FOOTER //
// ./web/flows/deal/investors/invited/index.js